import { render, staticRenderFns } from "./JgpPanel.vue?vue&type=template&id=0266c2ec&"
import script from "./JgpPanel.vue?vue&type=script&lang=js&"
export * from "./JgpPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports